import { Component, OnInit, viewChild } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { ApiService } from '../../../../../shared/services/api.service';
import { API_ENDPOINTS } from '../../../../../shared/utils/const';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { PageEvent } from '@angular/material/paginator';


@Component({
  selector: 'app-feedback-question',
  templateUrl: './feedback-question.component.html',
  styleUrl: './feedback-question.component.css'
})
export class FeedbackQuestionComponent implements OnInit {

  form: FormGroup;
  data: any = {};
  transformedData: any;
  uniqueId: any;
  index: any = 0;
  answerOption: number = 0;
  disabledRows: Set<string> = new Set();

  dataSource: any[] = [];
  pageSizeOptions: number[] = [10, 20, 50, 100];
  page = 1;
  pageSize = 10;
  length: number = 0;
  Pagination =
    {
      "UserId": sessionStorage.getItem("iauserid"),
      "PageNumber": 1,
      "PageSize": 10,
      "SortColumn": "",
      "SortDirection": "",
      "SearchTerm": "",

    }
  hidePageSize = false;
  showPageSizeOptions = true;
  showFirstLastButtons = true;
  disabled = false;
  pageIndex = 0;
  pageEvent!: PageEvent;
  constructor(private fb: FormBuilder, private apiService: ApiService, private toastrService: ToastrService, private router: Router,) {

    this.form = this.fb.group({
      search: [''],
      questionArray: this.fb.array([this.createQuestion()]),
    });
  }

  ngOnInit(): void {
    this.LoadDetails(this.Pagination);
    this.addAnswerOption(this.answerOption);
  }

  LoadDetails(Pagination: any) {

    Pagination.SearchTerm = this.form.get('search')?.value;
    
    this.apiService.getRequest(API_ENDPOINTS.MSSIDC.GETCUSTOMFEEDBACK, Pagination).subscribe(
      result => {
        if (result.status) {
          
          this.dataSource = result.data;
          this.length = result.data[0]['totalCount'];

        } else {
          this.toastrService.error(result.message);
        }
      }
    )
  }

  onAction(uniqueId: any, action: any) {

    if (action === 'select') {
      // Mark the row as disabled
      this.disabledRows.add(uniqueId);
    }

    var action;
    var condition;
    if (action == "select") {
      action = action;
      condition = true;
    }
    else if (action == "DeActive") {
      action = "update"
      condition = true;
    } else {
      action = "update"
      condition = false;
    }

    var data = {
      UniqueId: uniqueId,
      Condition: condition,
      Actions: action
    }

    this.apiService.getRequest(API_ENDPOINTS.MSSIDC.GETCUSTOMINDQUESTION, data).subscribe(
      result => {
        if (result.status) {
          
          if (action == 'select') {
            this.patchQuestion(this.index, result.data);
          }
          else
            this.LoadDetails(this.Pagination);
        }
      }
    );
  }

  // Method to patch values to a specific question in the form array
  patchQuestion(index: number, data: any): void {
    
    if (index != 0)
      this.addQuestion();

    const questionGroup = this.questionArray.at(index) as FormGroup;

    questionGroup.patchValue({
      uniqueId: data.item1['uniqueId'],
      questionText: data.item1['questionText'],
      section: data.item1['section'],
      answerType: data.item1['answerType'],
      optionText: data.item2[0]['optionText']
    });

    // Clear existing options in the answerOptions array
    const answerOptionsArray = questionGroup.get('answerOptions') as FormArray;
    answerOptionsArray.clear();

    // Add new answerOptions controls dynamically based on item2
    data.item2.forEach((option: any) => {
      answerOptionsArray.push(this.fb.group({
        optionText: [option.optionText, Validators.required],
        answerRating: [option.answerRating, Validators.required]
      }));
    });


    if (this.hasDuplicateUniqueId()) {
      this.removeQuestion(index);
      this.index = index -= 1;
      alert('Cannot add duplicate Unique ID');
      return;
    } else
      this.index += 1;

  }

  // Check if any duplicate uniqueId exists in the FormArray
  hasDuplicateUniqueId(): boolean {
    const uniqueIds = this.questionArray.controls.map(group => group.get('uniqueId')?.value);
    const uniqueIdsSet = new Set(uniqueIds);
    return uniqueIds.length !== uniqueIdsSet.size;
  }

  onSearch() {
    this.LoadDetails(this.Pagination);
  }

  // Getter for questionArray FormArray
  get questionArray(): FormArray {
    return this.form.get('questionArray') as FormArray;
  }

  // Method to create a new FormGroup for a question with validations
  createQuestion(): FormGroup {
    return this.fb.group({
      uniqueId: [''], // Initially empty or set to a default value
      section: ['', Validators.required], // section is required
      questionText: ['', Validators.required],  // Question is required
      answerType: ['', Validators.required], // Answer Type is required
      //optionText: ['', Validators.required]
      answerOptions: this.fb.array([]) // Nested FormArray for answers
      //answerOptions: this.fb.array([], this.answerOptionsValidator)  // Answer Options are validated by custom validator
    });
  }

  // Create answer group inside a question
  createAnswerOption(): FormGroup {
    return this.fb.group({
      optionText: ['', Validators.required], // Option text
      answerRating: ['', Validators.required] // Answer rating
    });
  }



  answerOptionsValidator(control: AbstractControl): ValidationErrors | null {
    // Ensure the control is of type FormArray
    const formArray = control as FormArray;

    // Access the parent 'answerType' control to check its value
    const questionType = formArray.parent?.get('answerType')?.value;
    
    if (questionType !== 'Text' && formArray.length === 0) {
      // Return a validation error if answer options are required but empty
      return { 'answerOptionsRequired': true };
    }
    return null; // No validation errors
  }

  // Getter for the answerOptions FormArray for each question
  getAnswerOptions(index: number): FormArray {
    return this.questionArray.at(index).get('answerOptions') as FormArray;
  }

  // Add answer option for a specific question
  addAnswerOption(questionIndex: number): void {
    
    this.getAnswerOptions(questionIndex).push(this.createAnswerOption());
  }

  // Remove answer option for a specific question
  removeAnswerOption(questionIndex: number, answerIndex: number): void {
    //if(this.addAnswerOption)
    
    this.getAnswerOptions(questionIndex).removeAt(answerIndex);
  }

  // Add a new question (FormGroup) to the FormArray
  addQuestion(): void {
    
    this.questionArray.push(this.createQuestion());  // Add new question to the array
    this.answerOption += 1;
    this.addAnswerOption(this.answerOption);
  }

  // Remove a specific question from the FormArray
  removeQuestion(index: number): void {
    
    this.answerOption -= 1;
    this.questionArray.removeAt(index);  // Remove the question from the array
  }

  onPageChange(e: PageEvent) {

    this.pageEvent = e;
    this.length = e.length;
    this.pageSize = e.pageSize;
    this.pageIndex = e.pageIndex;

    this.Pagination.PageNumber = e.pageIndex + 1;
    this.Pagination.PageSize = e.pageSize;
    this.LoadDetails(this.Pagination);
  }

  // Handle form submission
  onSubmit(): void {
    
    if (this.form.valid) {
      //console.log(this.form.value);  // Form is valid, you can submit it

      this.data = {
        "questionArray": this.questionArray.value,
        "createdBy": sessionStorage.getItem('mssidcuserid') // sessionStorage.getItem('mssidcuserid') //'E4F9ACAE-D8CE-4F75-A70C-083E842C308E' //
      }
      this.apiService.postRequest(API_ENDPOINTS.MSSIDC.POSTCUSTOMFEEDBACK, this.data).subscribe(
        (result: any) => {
          //debugger;
          this.toastrService.success('Implementation Details added successfully!', 'Good job!');
          window.location.reload();
          this.LoadDetails(this.Pagination);
          //this.router.navigate(['/view_event']);
        },
        error => {
          this.toastrService.error(error, 'Information cannot be saved. Please check for errors indicated in red.');
          //console.error('Error saving data:', error);
        }
      );

    }
  }

  // Function to transform the original array
  transformData(data: any[]): any {
    // Map through each question and transform it
    const transformedArray = data.map(item => ({
      questionText: item.questionText,
      answerType: item.answerType.toLowerCase(),  // Convert answerType to lowercase
      optionText: item.optionText
    }));

    // Wrap the transformed array in an object with 'questionArray' as key
    return {
      questionArray: transformedArray
    };
  }

}
